import React, { useState } from 'react';
import { deleteSellerProperty, getSellerProperties } from '../api';
import CoreButton from '../components/core/Button';
import List from '../components/core/List';
import Wrapper from '../components/core/Wrapper';
import InfoCard from '../components/InfoCard';
import DeletePropertyModal from '../components/Modals/DeletePropertyModal';
//import YesNoPrompt from '../components/Modals/YesNoPrompt';
import Pagination from '../components/Pagination/Pagination';
import SellerPropertyForm from '../components/SellerPropertyForm/SellerPropertyForm';
import { handleGlobalApiCalls } from '../helpers/asyncActions';
import { getImageUrl } from '../helpers/images';
import { getSingularPluralWord } from '../i18n/translations';
import MoreIcon from '../images/icons/more.svg';
import { useGlobalContext } from '../stores/global';
import styles from './SellerProperties.module.scss';

export default function MeProperties() {
  const { dispatch, isLoading } = useGlobalContext();
  const [reasonForElimination, setReasonForElimination] = useState(
    'Vendida por Hauscanner'
  );
  const [isSold, setIsSold] = useState('vendida');
  const [triggerReload, setTriggerReload] = useState(false);
  const [idPropertyToDelete, setIdPropertyToDelete] = useState<string>();
  const [formProperty, setFormProperty] = useState<{
    id?: string;
    show: true;
  }>();

  const handleFormPropertyClose = () => {
    setFormProperty(undefined);
    setTriggerReload(!triggerReload);
  };

  const handleDeleteSellerProperty = (id: string) => {
    setIdPropertyToDelete(id);
  };

  const closeDialogDelete = () => {
    setIdPropertyToDelete(undefined);
  };

  const handleDialogDeleteSubmit = async () => {
    if (!idPropertyToDelete) return;

    handleGlobalApiCalls(dispatch, isLoading, null, () =>
      deleteSellerProperty(idPropertyToDelete, {
        deleteState: reasonForElimination,
        status: isSold,
      }).then(() => setTriggerReload(!triggerReload))
    ).finally(closeDialogDelete);
  };

  const valueStatus = (e: any) => {
    setIsSold(e);
  };

  const valueDeleteState = (e: any) => {
    setReasonForElimination(e);
  };

  return (
    <Pagination
      triggerReload={triggerReload}
      apiFn={getSellerProperties}
      render={(items, isLoading, error, paginationEl) => (
        <Wrapper subHeader={{ title: 'MIS PROPIEDADES' }}>
          {formProperty && (
            <SellerPropertyForm
              propertyId={formProperty.id}
              onClose={handleFormPropertyClose}
            />
          )}

          <CoreButton
            onClick={() => setFormProperty({ show: true })}
            label="Agregar Propiedad"
            className={styles.addPropertyBtn}
            iconUrl={MoreIcon}
          />

          {isLoading ? (
            <p>Cargando...</p>
          ) : !!error ? (
            <p>Error cargando propiedades</p>
          ) : items?.length === 0 ? (
            <p>No tienes propiedades</p>
          ) : (
            <List>
              {items?.map((property: any) => {
                const { rooms, toilets, squareMeters, type } =
                  property.info || {};

                const { id, description, attaches, status } = property;

                return (
                  <InfoCard
                    key={id}
                    image={getImageUrl(attaches?.[0], {
                      urn: '/info/thumbnail',
                    })}
                    title={description}
                    highlight={
                      <>
                        <span>
                          {property.info.rooms}{' '}
                          <span style={{ textTransform: 'capitalize' }}>
                            {getSingularPluralWord('room', rooms)}
                          </span>
                        </span>
                        {' | '}
                        {property.info.toilets}{' '}
                        <span style={{ textTransform: 'capitalize' }}>
                          {getSingularPluralWord('bathroom', toilets)}
                        </span>
                        {' | '}
                        {squareMeters} m<small>2</small>
                      </>
                    }
                    items={[
                      [type],
                      ['Estado de la propiedad', status],
                      [
                        (property.address?.city
                          ? `${property.address.city} | `
                          : '') + property.address?.neighbor ||
                          property.address?.name,
                      ],
                    ]}
                    price={property.prices.property}
                    actionItems={[
                      <button
                        aria-label="Editar"
                        onClick={() => setFormProperty({ show: true, id })}
                      >
                        <i className="fonticons fonticons-pencil" />
                      </button>,
                      <button
                        aria-label="Eliminar"
                        onClick={() => handleDeleteSellerProperty(id)}
                      >
                        <i className="fonticons fonticons-trash" />
                      </button>,
                    ]}
                  />
                );
              })}
            </List>
          )}

          {paginationEl}

          <DeletePropertyModal
            open={Boolean(idPropertyToDelete)}
            valueStatus={valueStatus}
            deleteState={valueDeleteState}
            onClose={closeDialogDelete}
            onYes={handleDialogDeleteSubmit}
          />
        </Wrapper>
      )}
    />
  );
}
